import { inject, Injectable } from '@angular/core';
import { TagResponse } from '../../../services/tag.service';
import { ConfirmHandler } from '../../dialog/dialog.model';
import { DialogService } from '../../dialog/dialog.service';
import { TagSelectionDialogComponent } from '../tag-selection-dialog.component';

export interface TagSelectionDialogData {
  multiple?: boolean;
  initialSelectionCount?: number;
  maxSelectionLimit?: number;
  disabledLabels?: string[];
  clientId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TagSelectionDialogService {
  private readonly _dialog = inject(DialogService);

  open(
    callback: ConfirmHandler<TagResponse[]>,
    options: {
      multiple?: boolean;
      maxSelectionLimit?: number;
      initialSelectionCount?: number;
      disabledLabels?: string[];
      clientId?: string;
    }
  ) {
    return this._dialog.open(
      TagSelectionDialogComponent,
      {
        multiple: options.multiple,
        maxSelectionLimit: options.maxSelectionLimit,
        initialSelectionCount: options.initialSelectionCount,
        disabledLabels: options.disabledLabels,
        clientId: options.clientId,
        onConfirm: callback,
      },
      {
        maxWidth: '560px',
        width: '100%',
      }
    );
  }
}
